<template>
    <v-container fluid>
        <v-toolbar class="elevation-1">
            <v-btn
                @click="fab = !fab"
                :color="fabColorDrivers"
                dark
                fab
                small
                elevation="1"
            >
                <v-icon size="18" v-if="!fab">mdi-filter-variant</v-icon>
                <v-icon size="18" v-else>close</v-icon>
            </v-btn>
            <v-slide-x-transition>
                <div v-show="fab" style="position: fixed; margin-left: 50px">
                    <v-btn
                        v-for="(button, index) in expectedStatusDrivers"
                        :key="index"
                        @click.stop="filterDrivers(index)"
                        :color="
                            expectedStatusDrivers[index].active
                                ? button.color
                                : '#999'
                        "
                        rounded
                        dark
                        small
                        class="mx-1"
                    >
                        {{ $t("message." + button.status) }}
                    </v-btn>
                </div>
            </v-slide-x-transition>
            <v-toolbar-title v-show="!fab" class="ml-2">
                {{ $t("message.Driver_Overview") }}
            </v-toolbar-title>
            <template v-slot:extension>
                <v-menu
                    ref="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            prepend-icon="event"
                            class="archive-picker"
                            v-model="fromFormatted"
                            readonly
                            v-on="on"
                            :loading="$store.getters.isDriverDateFromDefault"
                        >
                            <template v-slot:progress>
                                <v-progress-linear
                                    v-if="
                                        $store.getters.isDriverDateFromDefault
                                    "
                                    :value="100"
                                    color="success"
                                    absolute
                                    height="3"
                                >
                                </v-progress-linear>
                            </template>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="$store.state.DriverOverview.driversByDate.from"
                        no-title
                        scrollable
                        :max="new Date().toISOString().substr(0, 10)"
                    ></v-date-picker>
                </v-menu>

                <v-menu
                    ref="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            prepend-icon="event"
                            class="archive-picker"
                            v-model="toFormatted"
                            readonly
                            v-on="on"
                            :loading="$store.getters.isDriverDateToDefault"
                        >
                            <template v-slot:progress>
                                <v-progress-linear
                                    v-if="$store.getters.isDriverDateToDefault"
                                    :value="100"
                                    color="success"
                                    absolute
                                    height="3"
                                >
                                </v-progress-linear>
                            </template>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="$store.state.DriverOverview.driversByDate.to"
                        no-title
                        scrollable
                        :max="new Date().toISOString().substr(0, 10)"
                    ></v-date-picker>
                </v-menu>
                <v-tooltip
                    v-if="
                        !$store.getters.isDriverDateFromDefault ||
                        !$store.getters.isDriverDateToDefault
                    "
                    bottom
                >
                    <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            @click="setDatesToDefault()"
                            v-on="tooltip"
                            icon
                            rounded
                            medium
                            class="ml-1 mb-4"
                            :loading="$store.getters.getLoading"
                        >
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </template>
                    <span> {{ $t("message.ResetToDefaultDates") }} </span>
                    <v-progress-linear
                        :value="100"
                        color="success"
                        absolute
                        height="5"
                    >
                    </v-progress-linear>
                </v-tooltip>
            </template>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-dialog
            @keydown.esc="close"
            max-width="800"
            v-model="dialog"
            persistent
            scrollable
            :transition="
                $vuetify.breakpoint.smAndDown
                    ? 'slide-y-transition'
                    : 'scale-transition'
            "
            :fullscreen="$vuetify.breakpoint.smAndDown"
        >
            <v-card class="register-card">
                <v-card-title>
                    <span class="headline">{{
                        $t("message.Driver_Overview")
                    }}</span>
                    <v-spacer></v-spacer>
                    <v-btn id="close-btn" rounded icon @click="close">
                        <v-icon medium>cancel</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form">
                        <v-container>
                            <v-row justify="center" dense>
                                <!-- Name driver -->
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        disabled
                                        outlined
                                        filled
                                        dense
                                        :value="driver.driver_name"
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[0].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-text-field>
                                </v-col>

                                <!-- ID number -->
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        disabled
                                        outlined
                                        filled
                                        dense
                                        :value="driver.identification_number"
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[1].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-text-field>
                                </v-col>

                                <!-- ID type -->
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        disabled
                                        outlined
                                        filled
                                        dense
                                        :value="
                                            idTypes[
                                                driver.identification_type - 1
                                            ]
                                        "
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[2].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-text-field>
                                </v-col>

                                <!-- Status -->
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        disabled
                                        outlined
                                        filled
                                        dense
                                        :label="formHeaders[3].text"
                                        :value="
                                            expectedStatusDrivers[
                                                driver.expected_status
                                            ]
                                                ? $t(
                                                      'message.' +
                                                          expectedStatusDrivers[
                                                              driver
                                                                  .expected_status
                                                          ].status
                                                  )
                                                : ''
                                        "
                                    ></v-text-field>
                                </v-col>

                                <!-- Created at -->
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        disabled
                                        outlined
                                        filled
                                        dense
                                        :value="driver.created_at"
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[4].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-text-field>
                                </v-col>

                                <!-- Type -->
                                <v-col cols="12" md="4">
                                    <v-select
                                        v-model="driver.visit_type"
                                        :disabled="
                                            !$can('update', 'driveroverview')
                                        "
                                        :items="types"
                                        item-text="text"
                                        item-value="value"
                                        outlined
                                        :filled="
                                            !$can('update', 'driveroverview')
                                        "
                                        dense
                                        :rules="[rules.required]"
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[5].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-select>
                                </v-col>

                                <!-- Company -->
                                <v-col cols="12" md="6">
                                    <v-select
                                        :disabled="
                                            !$can('update', 'driveroverview')
                                        "
                                        outlined
                                        :filled="
                                            !$can('update', 'driveroverview')
                                        "
                                        dense
                                        v-model="driver.company_id"
                                        :items="companies"
                                        item-text="name"
                                        item-value="id"
                                        :rules="[rules.required]"
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[6].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-select>
                                </v-col>

                                <!-- Reference Number -->
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        :disabled="
                                            !$can('update', 'driveroverview')
                                        "
                                        outlined
                                        :filled="
                                            !$can('update', 'driveroverview')
                                        "
                                        dense
                                        v-model="driver.reference"
                                        :rules="[
                                            rules.required,
                                            rules.max127Chars,
                                        ]"
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[7].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-text-field>
                                </v-col>

                                <!-- Transporter -->
                                <v-col
                                    cols="12"
                                    :md="
                                        $can('readDockNumber', 'driveroverview')
                                            ? 3
                                            : 4
                                    "
                                >
                                    <v-text-field
                                        outlined
                                        :filled="
                                            !$can('update', 'driveroverview')
                                        "
                                        dense
                                        v-model="driver.transp_name"
                                        :disabled="
                                            !$can('update', 'driveroverview')
                                        "
                                        :rules="[
                                            rules.required,
                                            rules.max44Chars,
                                            rules.firstChar,
                                            rules.transporterAllowedCharacters,
                                        ]"
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[8].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-text-field>
                                </v-col>

                                <!-- Vehicle -->
                                <v-col
                                    cols="12"
                                    :md="
                                        $can('readDockNumber', 'driveroverview')
                                            ? 3
                                            : 4
                                    "
                                >
                                    <v-select
                                        :disabled="
                                            !$can('update', 'driveroverview')
                                        "
                                        outlined
                                        :filled="
                                            !$can('update', 'driveroverview')
                                        "
                                        dense
                                        v-model="driver.truck_type"
                                        :items="vehicles"
                                        item-text="text"
                                        item-value="value"
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[9].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-select>
                                </v-col>

                                <!-- License plate -->
                                <v-col
                                    cols="12"
                                    :md="
                                        $can('readDockNumber', 'driveroverview')
                                            ? 3
                                            : 4
                                    "
                                >
                                    <v-text-field
                                        :disabled="
                                            !$can('update', 'driveroverview')
                                        "
                                        outlined
                                        :filled="
                                            !$can('update', 'driveroverview')
                                        "
                                        dense
                                        spellcheck="false"
                                        v-model="driver.license_plate"
                                        :label="formHeaders[10].text"
                                        :rules="[
                                            rules.max31Chars,
                                            rules.licensePlateAllowedCharacters,
                                        ]"
                                    >
                                    </v-text-field>
                                </v-col>

                                <!-- Dock number -->
                                <v-col
                                    v-if="
                                        $can('readDockNumber', 'driveroverview')
                                    "
                                    cols="12"
                                    md="3"
                                >
                                    <v-select
                                        :disabled="
                                            !$can('update', 'driveroverview') ||
                                            !$can(
                                                'updateDockNumber',
                                                'driveroverview'
                                            )
                                        "
                                        outlined
                                        :filled="
                                            !$can('update', 'driveroverview')
                                        "
                                        dense
                                        v-model="driver.dock_number"
                                        :items="dockNumbers"
                                        :label="formHeaders[11].text"
                                    >
                                    </v-select>
                                </v-col>

                                <!-- Comment -->
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="driver.description"
                                        :disabled="
                                            !$can('update', 'driveroverview')
                                        "
                                        :loading="$store.getters.getLoading"
                                        outlined
                                        :filled="
                                            !$can('update', 'driveroverview')
                                        "
                                        dense
                                        :rules="[
                                            v =>
                                                v.length <= 90 ||
                                                'Comment must be 90 characters or less',
                                        ]"
                                    >
                                        <template v-slot:label>{{
                                            formHeaders[12].text
                                        }}</template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions v-if="$can('update', 'driveroverview')">
                    <v-spacer></v-spacer>
                    <v-btn class="list-button" @click="save">
                        <v-icon class="pr-2" color="success">save</v-icon>
                        {{ $t("message.SaveButton") }}
                    </v-btn>
                    <v-btn class="list-button" @click="close">
                        <v-icon class="pr-2" color="error">cancel</v-icon>
                        {{ $t("message.CancelButton") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-data-table
            :headers="headers"
            :loading="$store.getters.getLoading"
            :items="drivers"
            :search.sync="$store.getters.getSearch"
            :page.sync="pageNrOfCurrentStatus"
            :lang="this.$i18n.locale"
            :items-per-page="-1"
            class="elevation-5"
            sort-by="intCreatedAt"
            sort-desc
            height="calc(100vh - 220px - 48px - 40px)"
            fixed-header
            mobile-breakpoint="0"
            :footer-props="$store.getters.getFooterProps"
        >
            <template slot="item" slot-scope="props">
                <tr
                    class="text-no-wrap"
                    style="cursor: pointer"
                    @click="clickRow(props.item)"
                >
                    <td>
                        <v-btn
                            v-if="props.item.expected_status == 0"
                            class="body-1 font-weight-bold"
                            :ripple="false"
                            @click.stop
                            text
                            small
                            style="cursor: default"
                        >
                            <v-icon class="pr-2">mdi-clipboard</v-icon>
                            {{ $t("message.NotSet") }}
                        </v-btn>
                        <v-btn
                            v-if="props.item.expected_status == 1"
                            class="body-1 font-weight-bold"
                            :ripple="false"
                            @click.stop
                            text
                            small
                            style="cursor: default"
                        >
                            <v-icon class="pr-2" color="success">
                                mdi-clipboard-check
                            </v-icon>
                            {{ $t("message.PreRegistered") }}
                        </v-btn>
                        <v-btn
                            v-if="props.item.expected_status == 2"
                            class="body-1 font-weight-bold"
                            :ripple="false"
                            @click.stop
                            text
                            small
                            style="cursor: default"
                        >
                            <v-icon class="pr-2" color="warning">
                                mdi-clipboard-alert
                            </v-icon>
                            {{ $t("message.NotPreRegistered") }}
                        </v-btn>
                    </td>
                    <td>{{ props.item.transp_name }}</td>
                    <td>{{ props.item.company_name }}</td>
                    <td>{{ typeText(props.item.visit_type) }}</td>
                    <td>{{ props.item.reference }}</td>
                    <td>{{ props.item.created_at }}</td>
                    <td v-if="$can('readDockNumber', 'driveroverview')">
                        {{ props.item.dock_number }}
                    </td>

                    <td>
                        <v-tooltip
                            bottom
                            v-if="
                                props.item.description &&
                                props.item.description.length > 25
                            "
                        >
                            <template v-slot:activator="{ on }">
                                <div v-on="on">
                                    {{
                                        props.item.description.slice(0, 20) +
                                        "..."
                                    }}
                                </div>
                            </template>
                            <span>{{ props.item.description }}</span>
                        </v-tooltip>
                        <div v-else>{{ props.item.description }}</div>
                    </td>

                    <td v-if="$can('update', 'driveroverview')">
                        <v-tooltip
                            bottom
                            v-if="props.item.expected_status != 1"
                        >
                            <template v-slot:activator="{ on: tooltip }">
                                <v-btn
                                    v-on="{ ...tooltip }"
                                    class="caption font-weight-black mr-3"
                                    small
                                    @click.stop="
                                        setStatus(props.item.visitor_id, 1)
                                    "
                                >
                                    <v-icon class="pr-2" color="success">
                                        mdi-clipboard-check
                                    </v-icon>
                                    {{ $t("message.PreRegistered") }}
                                </v-btn>
                            </template>
                            <span>{{ $t("message.SetPreRegistered") }}</span>
                        </v-tooltip>

                        <v-tooltip
                            bottom
                            v-if="props.item.expected_status != 2"
                        >
                            <template v-slot:activator="{ on: tooltip }">
                                <v-btn
                                    v-on="{ ...tooltip }"
                                    class="caption font-weight-black mr-3"
                                    small
                                    @click.stop="
                                        setStatus(props.item.visitor_id, 2)
                                    "
                                >
                                    <v-icon class="pr-2" color="warning">
                                        mdi-clipboard-alert
                                    </v-icon>
                                    {{ $t("message.NotPreRegistered") }}
                                </v-btn>
                            </template>
                            <span>{{ $t("message.SetNotPreRegistered") }}</span>
                        </v-tooltip>

                        <v-tooltip
                            bottom
                            v-if="props.item.expected_status != 0"
                        >
                            <template v-slot:activator="{ on: tooltip }">
                                <v-btn
                                    v-on="{ ...tooltip }"
                                    class="caption font-weight-black mr-3"
                                    small
                                    @click.stop="
                                        setStatus(props.item.visitor_id, 0)
                                    "
                                >
                                    <v-icon class="pr-2"
                                        >mdi-undo-variant</v-icon
                                    >
                                    {{ $t("message.NotSet") }}
                                </v-btn>
                            </template>
                            <span>{{ $t("message.UnsetTooltip") }}</span>
                        </v-tooltip>
                    </td>
                </tr>
            </template>
            <v-alert
                slot="no-data"
                dense
                :value="true"
                class="body-1 my-3 text-capitalize"
                color="warning"
                icon="warning"
            >
                {{
                    $t("message.NoResults") +
                    " " +
                    $t("message.From") +
                    " " +
                    fromFormatted +
                    " " +
                    $t("message.To") +
                    " " +
                    toFormatted
                }}
            </v-alert>

            <v-alert
                slot="no-results"
                dense
                :value="true"
                color="error"
                class="body-1 my-3"
                icon="warning"
            >
                {{ $t("message.YourSearch") }} "{{ $store.getters.getSearch }}"
                {{ $t("message.NoResults") }}
            </v-alert>
        </v-data-table>
    </v-container>
</template>

<script>
import { formatDate } from "../utils/dates";

export default {
    data: () => ({
        fromFormatted: null,
        toFormatted: null,
        pageNoFilter: 1,

        types: [
            { text: "Load", value: 5 },
            { text: "Unload", value: 10 },
            { text: "Load & Unload", value: 15 },
            { text: "Customs clearance", value: 20 },
        ],

        idTypes: ["Identity Card", "Passport", "Drivers License"],

        vehicles: [
            { text: "Car", value: 0 },
            { text: "Van", value: 1 },
            { text: "Truck", value: 2 },
            { text: "Trailer Truck", value: 3 },
        ],

        driver: {
            driver_name: "",
            identification_number: "",
            identification_type: "",
            visit_type: "",
            truck_type: "",
            company_id: "",
            reference: "",
            transp_name: "",
            license_plate: "",
            dock_number: "",
        },

        expectedStatusDrivers: [
            {
                status: "NotSet",
                active: true,
                color: "black",
                page: 1,
            },
            {
                status: "PreRegistered",
                active: false,
                color: "success",
                page: 1,
            },
            {
                status: "NotPreRegistered",
                active: false,
                color: "warning",
                page: 1,
            },
        ],
        fab: true,
        dialog: false,
        sorting: {
            by: "status",
            desc: false,
        },
        changed: false,
    }),

    computed: {
        companies() {
            return [...this.$store.getters.getCompanies].sort((a, b) => {
                if (a.name < b.name) return -1;
                return Number(a.name > b.name);
            });
        },

        transporters() {
            return [...this.$store.getters.getTransporter].sort((a, b) => {
                if (a.name < b.name) return -1;
                return Number(a.name > b.name);
            });
        },

        dockNumbers() {
            const dockNumbers = [];
            for (let i = 1; i <= 26; i++) {
                dockNumbers.push(i);
            }
            return dockNumbers;
        },

        pageNrOfCurrentStatus: {
            get() {
                for (const elem of this.expectedStatusDrivers) {
                    if (elem.active) {
                        return elem.page;
                    }
                }
                return this.pageNoFilter;
            },
            set(val) {
                for (const elem of this.expectedStatusDrivers) {
                    if (elem.active) {
                        elem.page = val;
                        return;
                    }
                }
                this.pageNoFilter = val;
            },
        },
        drivers() {
            return this.$store.getters.getDriversByDate.filter(item => {
                const filters =
                    !this.expectedStatusDrivers[0].active &&
                    !this.expectedStatusDrivers[1].active &&
                    !this.expectedStatusDrivers[2].active;
                return (
                    this.expectedStatusDrivers[item.expected_status].active ||
                    filters
                );
            });
        },
        typeText() {
            return type => {
                const foundType = this.types.find(x => x.value === type);
                if (foundType) return foundType.text;
                return "-";
            };
        },
        rules() {
            return {
                required: value => !!value || this.$t("message.FieldRequired"),
                firstChar: value => {
                    const error = this.$t("message.FirstCharTransporter");
                    return (
                        (value && /^[A-Z-0-9]*$/.test(value.charAt(0))) || error
                    );
                },
                date: value => {
                    const pattern =
                        /(^(((0[1-9]|1[0-9]|2[0-8])[-](0[1-9]|1[012]))|((29|30|31)[-](0[13578]|1[02]))|((29|30)[-](0[4,6,9]|11)))[-](19|[2-9][0-9])\d\d$)|(^29[-]02[-](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|40|56|60|64|68|72|76|80|84|88|92|96)$)/;
                    return (
                        pattern.test(value) || this.$t("message.InvalidDate")
                    );
                },
                licensePlateAllowedCharacters: value => {
                    const error = this.$t("message.SpecialCharacters");
                    return /^([a-zA-Z0-9 -]*)$/.test(value) || error;
                },

                transporterAllowedCharacters: value => {
                    const error = this.$t("message.SpecialCharacters");
                    return /^([a-zA-Z0-9. /()_-]+)$/.test(value) || error;
                },
                dockNumberInteger: value => {
                    const error = this.$t("message.OnlyInteger");
                    return /^([0-9]*)$/.test(value) || error;
                },
                max31Chars: value => {
                    const error = this.$t("message.Max31Chars");
                    return !value || value.length <= 31 || error;
                },
                max44Chars: value => {
                    const error = this.$t("message.Max44Chars");
                    return !value || value.length <= 44 || error;
                },
                max127Chars: value => {
                    const error = this.$t("message.Max127Chars");
                    return !value || value.toString().length < 128 || error;
                },
            };
        },
        fabColorDrivers() {
            const currentExpectedStatus = this.expectedStatusDrivers.find(
                expectedStatus => expectedStatus.active
            );
            return currentExpectedStatus
                ? this.determineColorDrivers(currentExpectedStatus.status)
                : "primary";
        },
        determineColorDrivers() {
            return expectedStatus => {
                switch (expectedStatus) {
                    case "NotSet":
                        return "black";
                    case "PreRegistered":
                        return "success";
                    case "NotPreRegistered":
                        return "warning";
                    default:
                        return "";
                }
            };
        },
        headers() {
            return [
                {
                    text: this.$t("message.Status"),
                    value: "status",
                    sortable: false,
                },
                {
                    text: this.$t("message.Transporter"),
                    value: "transp_name",
                    sortable: true,
                },
                {
                    text: this.$t("message.Company"),
                    value: "company_id",
                    sortable: true,
                },
                {
                    text: this.$t("message.Type"),
                    value: "visit_type",
                    sortable: true,
                },
                {
                    text: this.$t("message.Reference"),
                    value: "reference",
                    sortable: true,
                },
                {
                    text: this.$t("message.CreationDate"),
                    value: "intCreatedAt",
                    sortable: true,
                },
                {
                    text: this.$t("message.DockNumber"),
                    value: "dock_number",
                    sortable: true,
                    hidden: !this.$can("readDockNumber", "driveroverview"),
                },
                {
                    text: this.$t("message.Comment"),
                    value: "description",
                    sortable: false,
                },
                {
                    text: this.$t("message.Actions"),
                    value: "actions",
                    sortable: false,
                    hidden: !this.$can("update", "driveroverview"),
                },
            ].filter(column => !column.hidden);
        },

        formHeaders() {
            return [
                {
                    text: this.$t("message.NameDriver"),
                    value: "driver",
                },
                {
                    text: this.$t("message.IdNumber"),
                    value: "id_number",
                },
                {
                    text: this.$t("message.IdType"),
                    value: "id_type",
                },
                {
                    text: this.$t("message.Status"),
                    value: "status",
                },
                {
                    text: this.$t("message.CreationDate"),
                    value: "created_at",
                },
                {
                    text: this.$t("message.Type"),
                    value: "visit_type",
                },
                {
                    text: this.$t("message.Company"),
                    value: "company_name",
                },
                {
                    text: this.$t("message.Reference"),
                    value: "reference",
                },
                {
                    text: this.$t("message.Transporter"),
                    value: "transporter",
                },
                {
                    text: this.$t("message.Vehicle"),
                    value: "vehicle",
                },
                {
                    text: this.$t("message.LicensePlate"),
                    value: "license_plate",
                },
                {
                    text: this.$t("message.DockNumber"),
                    value: "dock_number",
                },
                {
                    text: this.$t("message.Comment"),
                    value: "description",
                },
            ];
        },
        isFilled() {
            return (
                !!this.driver.reference &&
                !!this.driver.company_id &&
                !!this.driver.transp_name &&
                !!this.driver.visit_type
            );
        },
        isInputValid() {
            return !(
                this.rules.max31Chars(this.driver.license_plate) ===
                    this.$t("message.Max31Chars") ||
                this.rules.transporterAllowedCharacters(
                    this.driver.transp_name
                ) === this.$t("message.SpecialCharacters") ||
                this.rules.licensePlateAllowedCharacters(
                    this.driver.license_plate
                ) === this.$t("message.SpecialCharacters") ||
                this.rules.max31Chars(this.driver.license_plate) ===
                    this.$t("message.Max31Chars") ||
                this.rules.max127Chars(this.driver.reference) ===
                    this.$t("message.Max127Chars")
            );
        },
    },
    mounted() {
        this.$store.dispatch("processDriversByDate");
        this.$store.dispatch("processCompanies");
        this.$store.dispatch("processTransporter");

        this.initialize();
    },
    watch: {
        "$store.state.DriverOverview.driversByDate.from": async function (val) {
            if (
                this.$store.state.DriverOverview.driversByDate.from >
                this.$store.state.DriverOverview.driversByDate.to
            ) {
                this.$store.state.DriverOverview.driversByDate.to =
                    this.$store.state.DriverOverview.driversByDate.from;
            }
            this.fromFormatted = formatDate(val);
            await this.$store.dispatch("processDriversByDate");
            this.$refs.menu1.callDeactivate();
        },
        "$store.state.DriverOverview.driversByDate.to": async function (val) {
            if (
                this.$store.state.DriverOverview.driversByDate.to <
                this.$store.state.DriverOverview.driversByDate.from
            ) {
                this.$store.state.DriverOverview.driversByDate.from =
                    this.$store.state.DriverOverview.driversByDate.to;
            }
            this.toFormatted = formatDate(val);
            await this.$store.dispatch("processDriversByDate");
            this.$refs.menu2.callDeactivate();
        },
        driver: {
            handler() {
                this.changed = true;
            },
            deep: true,
        },
        dialog(val) {
            if (val) this.changed = false;
        },
    },
    methods: {
        initialize() {
            this.fromFormatted = formatDate(
                this.$store.state.DriverOverview.driversByDate.from
            );
            this.toFormatted = formatDate(
                this.$store.state.DriverOverview.driversByDate.to
            );
        },
        close() {
            if (
                this.changed &&
                // TODO: USE Alert component instead
                // eslint-disable-next-line no-restricted-globals, no-alert
                !confirm("Are you sure ? Any unsaved changes will be lost.")
            ) {
                return;
            }

            this.dialog = false;
        },

        async save() {
            if (!this.isFilled || !this.isInputValid) {
                this.$refs.form.validate();
                return;
            }

            const data = Object.assign(this.driver);

            //console.log(data);

            // Check if transporter name already exists
            const matchTransporter = transporter => {
                const compareCaseInsensitive =
                    transporter.name.toLowerCase() ===
                    this.driver.transp_name.toLowerCase();
                return compareCaseInsensitive;
            };
            const foundTransporter = this.transporters.find(matchTransporter);
            if (foundTransporter) {
                data.transporter_id = foundTransporter.id;
            } else {
                const response = await this.$store.dispatch("addTransporter", {
                    name: this.driver.transp_name,
                });
                data.transporter_id = response.id;
            }

            this.$store.dispatch("editDriverOverview", data);
            this.dialog = false;
        },

        setDatesToDefault() {
            this.$store.state.DriverOverview.driversByDate.from =
                this.$store.state.DriverOverview.driversByDate.defaultFrom;
            this.$store.state.DriverOverview.driversByDate.to =
                this.$store.state.DriverOverview.driversByDate.defaultTo;
        },
        clickRow(row) {
            this.driver = Object.assign({}, row);
            this.dialog = true;
            this.setFocus();
        },
        setStatus(id, expectedStatus) {
            this.$store.dispatch("setStatus", {
                id,
                status: expectedStatus,
            });
        },
        filterDrivers(expectedStatus) {
            this.expectedStatusDrivers[expectedStatus].active =
                !this.expectedStatusDrivers[expectedStatus].active;
            for (let i = 0; i < this.expectedStatusDrivers.length; i += 1) {
                if (i !== expectedStatus) {
                    this.expectedStatusDrivers[i].active = false;
                }
            }
        },
    },
};
</script>
